export const API_MESSAGE_CONTENT_REQUEST = 'API_MESSAGE_CONTENT_REQUEST';
export const API_MESSAGE_CONTENT_SUCCESS = 'API_MESSAGE_CONTENT_SUCCESS';
export const API_MESSAGE_CONTENT_FAILURE = 'API_MESSAGE_CONTENT_FAILURE';

export const RESET_SELECTION_MESSAGE = 'RESET_SELECTION_MESSAGE';

export const resetSelectionMessage = payload => ({
  type: RESET_SELECTION_MESSAGE,
  payload,
});


export const messageContentRequest = payload => ({
  type: API_MESSAGE_CONTENT_REQUEST,
  payload,
});

export const messageContentSuccess = payload => ({
  type: API_MESSAGE_CONTENT_SUCCESS,
  payload,
});

export const messageContentFailure = payload => ({
  type: API_MESSAGE_CONTENT_FAILURE,
  payload,
});

const initialState = {
  selectedMessageId: null,
  isFetched: false,
  fetching: false,
  error: null,
  message: null,
};

export function messageContentReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_SELECTION_MESSAGE:
      return {
        ...state,
        fetching: true,
        selectedMessageId: null,
      };
    case API_MESSAGE_CONTENT_REQUEST:
      return {
        ...state,
        fetching: true,
        selectedMessageId: action.payload,
      };
    case API_MESSAGE_CONTENT_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        message: action.payload,
      };
    case API_MESSAGE_CONTENT_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}
